import { ITemple } from 'pages/apps/Temple/types';
import { TempleActionTypes } from './constants';

export type TempleActionType = {
    type:
        | TempleActionTypes.API_RESPONSE_SUCCESS
        | TempleActionTypes.API_RESPONSE_ERROR
        | TempleActionTypes.GET_TEMPLES
        | TempleActionTypes.ADD_TEMPLE
        | TempleActionTypes.DELETE_TEMPLE
        | TempleActionTypes.GET_TEMPLE_DETAILS
        | TempleActionTypes.UPDATE_TEMPLE
        | TempleActionTypes.GET_APPROVAL_REQUESTS
        | TempleActionTypes.UPDATE_APPROVAL_REQUEST
        | TempleActionTypes.RESET;

    payload: any;
};

// Common success
export const templeApiResponseSuccess = (
    actionType: string,
    data: any
): TempleActionType => ({
    type: TempleActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// Common error
export const templeApiResponseError = (
    actionType: string,
    error: string
): TempleActionType => ({
    type: TempleActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// Get temples
export const getTemples = (params: any): TempleActionType => ({
    type: TempleActionTypes.GET_TEMPLES,
    payload: params,
});

// Add temple
export const addTemple = (params: any): TempleActionType => ({
    type: TempleActionTypes.ADD_TEMPLE,
    payload: params,
});

// Get temple details
export const getTempleByIdAction = (
    templeId: number
): TempleActionType => ({
    type: TempleActionTypes.GET_TEMPLE_DETAILS,
    payload: { templeId },
});

// Update temple
export const updateTempleByIdAction = (
    templeData: any
): TempleActionType => ({
    type: TempleActionTypes.UPDATE_TEMPLE,
    payload: templeData,
});

// Delete temple
export const deleteTempleByIdAction = (
    templeId: number
): TempleActionType => ({
    type: TempleActionTypes.DELETE_TEMPLE,
    payload: templeId,
});

// Get approval requests
export const getApprovalRequests = (
    params?: {
        status?: string;
        templeId?: number;
    }
): TempleActionType => ({
    type: TempleActionTypes.GET_APPROVAL_REQUESTS,
    payload: params || {},
});

// Update approval request
export const updateApprovalRequest = (
    requestId: number,
    data: {
        status: 'APPROVED' | 'REJECTED';
        remarks?: string;
    }
): TempleActionType => ({
    type: TempleActionTypes.UPDATE_APPROVAL_REQUEST,
    payload: {
        requestId,
        ...data,
    },
});

// Reset temple state
export const resetTempleState = (): TempleActionType => ({
    type: TempleActionTypes.RESET,
    payload: {},
});